import { render, staticRenderFns } from "./WorkflowFormBuilderCalculationTab.vue?vue&type=template&id=97ea63cc&"
import script from "./WorkflowFormBuilderCalculationTab.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderCalculationTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports